export const blockIconsAndroidSplitscreenNew = (
	<span className='material-symbols-outlined'>splitscreen</span>
);
